import React from 'react';
import Header from '../components/Header';

import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="App">
      <Header />

      <main>
        <Hero />
        <Services />
        <About showDiagram={false} />
      </main>
      <Footer />
    </div>
  );
};

export default Home;

